export function findComponentBindingContext(bindingContext: KnockoutBindingContext): KnockoutBindingContext {
    if (!bindingContext.$component) {
        throw "Binding context is not within a component.";
    }

    if (bindingContext.$component === bindingContext.$data) {
        return bindingContext;
    } else {
        return findComponentBindingContext(bindingContext.$parentContext);
    }
}
